export default "__VITE_ASSET__BRi$SQDZ__"